<div class="container mt-4">
    <div class="row">
        <div class="col-8">
            <app-pagetitle title="Cron Jobs"></app-pagetitle>
        </div>
        <div class="col-4">
            <button class="btn btn-primary btn-sm float-end" (click)="openCreateModal(planModal)">
                <i class="mdi mdi-plus"></i> Add Cron Job
            </button>
        </div>
    </div>

    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">



            <div class="card">
                @if( cronJobs.length > 0) {
                <div class="card-body">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Method</th>
                                <th>URL</th>
                                <th>Schedule</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let job of cronJobs">
                                <td>{{ job.name }}</td>
                                <td>{{ job.method }}</td>
                                <td>{{ job.url }}</td>
                                <td>{{ job.schedule }}</td>
                                <td>
                                    <i class="mdi mdi-pencil font-size-18 text-primary me-2 cursor-pointer"
                                        (click)="openEditModal(job, planModal)"></i>

                                    <i class="mdi mdi-delete font-size-18 text-danger cursor-pointer"
                                        (click)="deleteCronJob(job._id)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                }@else {
                <div class="card-body">
                    <p class="text-muted text-center w-100">
                        No cron jobs found.
                    </p>
                </div>
                }
            </div>

            <!-- Modal -->
            <ng-template #planModal let-modal>
                <div class="modal-header">
                    <h4 class="modal-title">{{ isEditMode ? 'Edit' : 'Add' }} Cron Job</h4>
                    <button type="button" class="btn-close" aria-label="Close"
                        (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body">
                    <form [formGroup]="cronJobForm" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label for="name" class="form-label">Name</label>
                                <input type="text" class="form-control" id="name" formControlName="name" required>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="method" class="form-label">Method</label>
                                <select class="form-control" id="method" formControlName="method">
                                    <option value="GET">GET</option>
                                    <option value="POST">POST</option>
                                    <option value="PUT">PUT</option>
                                    <option value="PATCH">PATCH</option>
                                    <option value="DELETE">DELETE</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label for="url" class="form-label">URL</label>
                                <input type="url" class="form-control" id="url" formControlName="url" required>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="schedule" class="form-label">Schedule</label>
                                <input type="text" class="form-control" id="schedule" formControlName="schedule"
                                    placeholder="*/3 * * * * *" required>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!cronJobForm.valid" (click)="onSubmit()">
                        {{ isEditMode ? 'Update' : 'Create' }} Cron Job
                    </button>
                </div>
            </ng-template>
        </div>

    </div>
</div>